import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'no-chose-icon',
  templateUrl: './no-chose-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NoChoseIconComponent {}
